// src/utils/zodiacUtils.js
// Function to get zodiac sign from date of birth
import { getZodiacInfo, getZodiacColor } from './zodiacData';

// Function to get zodiac sign from date of birth
export const getZodiacSign = (dob) => {
  if (!dob) return getZodiacInfo('unknown');
  
  try {
    // Parse date in DD-MM-YYYY format
    const parts = dob.split('-');
    if (parts.length !== 3) return getZodiacInfo('unknown');
    
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    
    if (isNaN(day) || isNaN(month)) {
      return getZodiacInfo('unknown');
    }
    
    // Determine zodiac sign based on date
    if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) {
      return getZodiacInfo('aquarius');
    } else if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) {
      return getZodiacInfo('pisces');
    } else if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) {
      return getZodiacInfo('aries');
    } else if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) {
      return getZodiacInfo('taurus');
    } else if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) {
      return getZodiacInfo('gemini');
    } else if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) {
      return getZodiacInfo('cancer');
    } else if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) {
      return getZodiacInfo('leo');
    } else if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) {
      return getZodiacInfo('virgo');
    } else if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) {
      return getZodiacInfo('libra');
    } else if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) {
      return getZodiacInfo('scorpio');
    } else if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) {
      return getZodiacInfo('sagittarius');
    } else if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) {
      return getZodiacInfo('capricorn');
    }
    
    return getZodiacInfo('unknown');
  } catch (error) {
    console.error('Error calculating zodiac sign:', error);
    return getZodiacInfo('unknown');
  }
};

// Function to get zodiac compatibility
export const getZodiacCompatibility = (sign) => {
  const compatibilityMatrix = {
    'Aries': { 
      best: ['Leo', 'Sagittarius'], 
      good: ['Gemini', 'Aquarius'], 
      avoid: ['Cancer', 'Capricorn'] 
    },
    'Taurus': { 
      best: ['Virgo', 'Capricorn'], 
      good: ['Cancer', 'Pisces'], 
      avoid: ['Leo', 'Aquarius'] 
    },
    'Gemini': { 
      best: ['Libra', 'Aquarius'], 
      good: ['Aries', 'Leo'], 
      avoid: ['Virgo', 'Pisces'] 
    },
    'Cancer': { 
      best: ['Scorpio', 'Pisces'], 
      good: ['Taurus', 'Virgo'], 
      avoid: ['Aries', 'Libra'] 
    },
    'Leo': { 
      best: ['Aries', 'Sagittarius'], 
      good: ['Gemini', 'Libra'], 
      avoid: ['Taurus', 'Scorpio'] 
    },
    'Virgo': { 
      best: ['Taurus', 'Capricorn'], 
      good: ['Cancer', 'Scorpio'], 
      avoid: ['Gemini', 'Sagittarius'] 
    },
    'Libra': { 
      best: ['Gemini', 'Aquarius'], 
      good: ['Leo', 'Sagittarius'], 
      avoid: ['Cancer', 'Capricorn'] 
    },
    'Scorpio': { 
      best: ['Cancer', 'Pisces'], 
      good: ['Virgo', 'Capricorn'], 
      avoid: ['Leo', 'Aquarius'] 
    },
    'Sagittarius': { 
      best: ['Aries', 'Leo'], 
      good: ['Libra', 'Aquarius'], 
      avoid: ['Virgo', 'Pisces'] 
    },
    'Capricorn': { 
      best: ['Taurus', 'Virgo'], 
      good: ['Scorpio', 'Pisces'], 
      avoid: ['Aries', 'Libra'] 
    },
    'Aquarius': { 
      best: ['Gemini', 'Libra'], 
      good: ['Aries', 'Sagittarius'], 
      avoid: ['Taurus', 'Scorpio'] 
    },
    'Pisces': { 
      best: ['Cancer', 'Scorpio'], 
      good: ['Taurus', 'Capricorn'], 
      avoid: ['Gemini', 'Sagittarius'] 
    },
    'Unknown': { 
      best: [], 
      good: [], 
      avoid: [] 
    }
  };
  
  return compatibilityMatrix[sign] || compatibilityMatrix['Unknown'];
};

// Re-export the color and info functions
export { getZodiacColor, getZodiacInfo };